import { useIsMerchant } from "./use-is-merchant";
import { splitByReturnability } from "../lib/returnable-items.lib";
import { usePublicOrder } from "../queries/use-public-order";
import { useReturnRequests } from "../queries/use-return-requests";
import type { OrderLineItem } from "../types";

/**
 * Line items the shop excluded from returns, shown as disabled rows with a
 * badge in the article selection list. Empty for a merchant, who selects them
 * like any other article.
 */
export function useNonReturnableItems(
  orderId: string,
  shopSlug: string,
): OrderLineItem[] {
  const { data: order } = usePublicOrder(orderId);
  const { data: returnRequestsData } = useReturnRequests({ orderId, shopSlug });
  const isMerchant = useIsMerchant();

  if (isMerchant) return [];

  return splitByReturnability(
    order?.lineItems ?? [],
    returnRequestsData?.returnRequests ?? [],
  ).nonReturnable;
}
